import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import {
  getAllSizes,
  addSize,
  updateSize,
  deleteSize,
} from "../../../services/size.service";

const SizeMaster = () => {
  const [sizes, setSizes] = useState([]);
  const [newSize, setNewSize] = useState("");
  const [editSizeId, setEditSizeId] = useState(null);
  const [editSizeValue, setEditSizeValue] = useState("");
  const { token } = useSelector((state) => state?.auth);

  const fetchSizes = async () => {
    try {
      const res = await getAllSizes(token);
      if (res && res.status >= 200 && res.status < 300) {
        // console.log(res.data);
        setSizes(res.data);
      } else {
        Swal.fire("Error", "Failed to fetch sizes.", "error");
      }
    } catch (error) {
      console.error("Error fetching sizes:", error);
      Swal.fire("Error", "Network or server error occurred.", "error");
    }
  };

  useEffect(() => {
    fetchSizes();
  }, []);

  const handleAddSize = async () => {
    if (newSize.trim() === "") {
      Swal.fire("Error", "Please enter a valid size", "error");
      return;
    }

    try {
      const res = await addSize(token, { size: newSize.trim() });
      if (res && res.status >= 200 && res.status < 300) {
        Swal.fire("Success", "Size added successfully", "success").then(() => {
          fetchSizes();
          setNewSize("");
        });
      } else {
        Swal.fire(
          "Error",
          res?.data?.size[0] || "Failed to add size.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error adding size:", error);
      Swal.fire("Error", "Network or server error occurred.", "error");
    }
  };

  const handleDeleteSize = async (sizeId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This size will be permanently deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await deleteSize(token, sizeId);
          if (res && res.status >= 200 && res.status < 300) {
            Swal.fire("Deleted!", "Size has been deleted.", "success").then(
              () => {
                fetchSizes();
              }
            );
          } else {
            Swal.fire(
              "Error",
              res?.data?.message || "Failed to delete size.",
              "error"
            );
          }
        } catch (error) {
          console.error("Error deleting size:", error);
          Swal.fire("Error", "Network or server error occurred.", "error");
        }
      }
    });
  };

  const handleSaveEditSize = async () => {
    if (editSizeValue.trim() === "") {
      Swal.fire("Error", "Please enter a valid size", "error");
      return;
    }

    try {
      const res = await updateSize(
        token,
        { size: editSizeValue.trim() },
        editSizeId
      );
      if (res && res.status >= 200 && res.status < 300) {
        Swal.fire("Success", "Size updated successfully", "success").then(
          () => {
            fetchSizes();
            setEditSizeId(null);
            setEditSizeValue("");
          }
        );
      } else {
        Swal.fire(
          "Error",
          res?.data?.size[0] || "Failed to update size.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error updating size:", error);
      Swal.fire("Error", "Network or server error occurred.", "error");
    }
  };

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h4 className="card-title">Product Size Master</h4>
                <Link to="/products">
                  <img
                    src="/assets/images/kidskart/icon/back-button.png"
                    alt="Back"
                  />
                </Link>
              </div>

              <div className="card-body">
                <div className="mb-4 d-flex align-items-center">
                  <input
                    type="text"
                    className="form-control me-2 input-size"
                    value={newSize}
                    onChange={(e) => setNewSize(e.target.value)}
                    placeholder="Enter new size (e.g., 'Large')"
                  />
                  <button className="btn btn-primary" onClick={handleAddSize}>
                    Add Size
                  </button>
                </div>

                <div className="row">
                  <div className="col-xl-12">
                    <div className="table-responsive">
                      <table
                        id="example5"
                        className="table order-request2 display mb-4 dataTablesCard dataTable no-footer"
                        role="grid"
                        aria-describedby="example5_info"
                      >
                        <thead>
                          <tr role="row">
                            <th>
                              <strong className="font-w600">#</strong>
                            </th>
                            <th>
                              <strong className="font-w600">Size</strong>
                            </th>
                            <th>
                              <strong className="font-w600">Actions</strong>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {sizes.map((item, i) => (
                            <tr role="row" className="odd" key={item.size_id}>
                              <td>{i + 1}</td>
                              <td>
                                {editSizeId === item.size_id ? (
                                  <input
                                    type="text"
                                    className="form-control"
                                    style={{ minWidth: "200px" }}
                                    value={editSizeValue}
                                    onChange={(e) =>
                                      setEditSizeValue(e.target.value)
                                    }
                                  />
                                ) : (
                                  item.size
                                )}
                              </td>
                              <td>
                                {editSizeId === item.size_id ? (
                                  <div className="d-flex">
                                    <button
                                      className="btn btn-success py-1 me-2"
                                      style={{ width: "100px" }}
                                      onClick={handleSaveEditSize}
                                    >
                                      Save
                                    </button>
                                    <button
                                      className="btn btn-secondary py-1"
                                      style={{ width: "100px" }}
                                      onClick={() => setEditSizeId(null)}
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                ) : (
                                  <div className="d-flex align-items-center">
                                    <img
                                      onClick={() =>
                                        setEditSizeId(item.size_id) ||
                                        setEditSizeValue(item.size)
                                      }
                                      src="/assets/images/kidskart/icon/edit.png"
                                      alt="Edit"
                                      className="ms-3 cursor-pointer"
                                    />
                                    <img
                                      onClick={() =>
                                        handleDeleteSize(item.size_id)
                                      }
                                      src="/assets/images/kidskart/icon/trash-bin.png"
                                      className="ms-1 d-none cursor-pointer"
                                      alt="Delete"
                                    />
                                  </div>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SizeMaster;
